import React from 'react';

export default class PageComponent extends React.Component {
    constructor(props) {
        super(props);
        global.page = this;
        this.state = {
            language: global.applanguage
        };
        this.state.isModalVisible = null;
        this.state.modalInitializing = false;
        this.state.modalLoading = false;
        this.state.modalError = null;
        this.state.error = null;
    }

    componentDidMount() {
        this.setState({ language: global.applanguage });
    }

}